import React from 'react';
import { Typography, Divider, Card, Row, Col } from 'antd';
import { MailOutlined, PhoneOutlined, MessageOutlined } from '@ant-design/icons';
import { useLanguage } from '../store/LanguageContext';
import { CN_CONTACT_PHONE, contactEmail, WECOM_QR_SRC } from '../utils/site';

const { Title, Paragraph, Text } = Typography;

const ContactPage: React.FC = () => {
  const { t } = useLanguage();
  const email = contactEmail();

  return (
    <div style={{ maxWidth: 880, margin: '0 auto', padding: '48px 24px 80px' }}>
      <Title level={2}>{t('contact.title')}</Title>
      <Paragraph type="secondary">{t('contact.subtitle')}</Paragraph>
      <Divider />

      <Row gutter={[24, 24]}>
        <Col xs={24} sm={12} md={8}>
          <Card
            hoverable
            style={{ textAlign: 'center', borderRadius: 12, height: '100%' }}
            bodyStyle={{ padding: '28px 20px' }}
          >
            <MailOutlined style={{ fontSize: 32, color: '#1677ff', marginBottom: 12 }} />
            <Title level={5} style={{ marginBottom: 4 }}>{t('contact.emailTitle')}</Title>
            <Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 12 }}>
              {t('contact.emailDesc')}
            </Paragraph>
            <a href={`mailto:${email}`}>
              <Text strong style={{ color: '#1677ff', wordBreak: 'break-all' }}>{email}</Text>
            </a>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card
            hoverable
            style={{ textAlign: 'center', borderRadius: 12, height: '100%' }}
            bodyStyle={{ padding: '28px 20px' }}
          >
            <PhoneOutlined style={{ fontSize: 32, color: '#13c2c2', marginBottom: 12 }} />
            <Title level={5} style={{ marginBottom: 4 }}>电话</Title>
            <Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 12 }}>
              工作日可致电咨询
            </Paragraph>
            <a href={`tel:${CN_CONTACT_PHONE.replace(/-/g, '')}`}>
              <Text strong style={{ color: '#1677ff', fontSize: 18 }}>{CN_CONTACT_PHONE}</Text>
            </a>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card
            hoverable
            style={{ textAlign: 'center', borderRadius: 12, height: '100%' }}
            bodyStyle={{ padding: '28px 20px' }}
          >
            <MessageOutlined style={{ fontSize: 32, color: '#52c41a', marginBottom: 12 }} />
            <Title level={5} style={{ marginBottom: 4 }}>意见反馈</Title>
            <Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 12 }}>
              {t('contact.feedbackDesc')}
            </Paragraph>
            <a href="/feedback">
              <Text strong style={{ color: '#1677ff' }}>{t('contact.feedbackLink')}</Text>
            </a>
          </Card>
        </Col>
      </Row>

      <Card
        style={{ marginTop: 28, borderRadius: 12 }}
        bodyStyle={{ padding: '28px 24px' }}
      >
        <Row gutter={[24, 16]} align="middle">
          <Col xs={24} md={10} style={{ textAlign: 'center' }}>
            <img
              src={WECOM_QR_SRC}
              alt="企业微信二维码"
              width={200}
              height={200}
              style={{
                width: 200,
                height: 200,
                objectFit: 'contain',
                borderRadius: 8,
                background: '#fff',
                border: '1px solid #f0f0f0',
              }}
            />
          </Col>
          <Col xs={24} md={14}>
            <Title level={4} style={{ marginTop: 0 }}>企业微信</Title>
            <Paragraph type="secondary" style={{ marginBottom: 8 }}>
              用手机企业微信 / 微信扫码，添加后可直接沟通合作与工具收录事宜。
            </Paragraph>
            <Paragraph style={{ marginBottom: 0 }}>
              <Text type="secondary">邮箱：</Text>
              <a href={`mailto:${email}`}>{email}</a>
              <br />
              <Text type="secondary">电话：</Text>
              <a href={`tel:${CN_CONTACT_PHONE.replace(/-/g, '')}`}>{CN_CONTACT_PHONE}</a>
            </Paragraph>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default ContactPage;
